import { get } from "lodash"
import { API, Auth, Hub } from "aws-amplify"

import {
  switchUser,
  updateCustomer,
  deleteCustomer,
  setSubscriptions,
  deleteSubscriptions,
  setOwnedProducts,
  deleteOwnedProducts,
  deleteAwsCredentials,
  deleteGcpCredentials,
  deleteAzureCredentials,
  resetPopups,
} from "./actions"
import { verifyActiveSubscriptions, getCurrentCustomer }  from "../graphql/queries"


function normaliseUser(user) {
  /*
  Normalise user so that they appear the same no matter how they logged in
  */
  if (get(user, "attributes")) {
    // Cognito user has details in attributes
    return get(user, "attributes")
  } else {
    // Google has details at root
    return user
  }
}

export class AmplifyBridge {
  constructor(store) {
    this.store = store
    this.authHandler = this.authHandler.bind(this)
    this.getUser = this.getUser.bind(this)
    this.getCustomer = this.getCustomer.bind(this)
    this.getActiveSubscriptions = this.getActiveSubscriptions.bind(this)

    Hub.listen("auth", this.authHandler)

    this.getUser()
  }


  authHandler(data) {
    console.log("Auth event", data.payload.event)
    switch (data.payload.event) {
      case "signIn":
        this.getUser()
        break
      case "signUp":
        this.getUser()
        break
      case "signOut":
        this.store.dispatch(switchUser(null))
        this.store.dispatch(deleteCustomer())
        this.store.dispatch(deleteSubscriptions())
        this.store.dispatch(deleteOwnedProducts())
        this.store.dispatch(deleteAwsCredentials())
        this.store.dispatch(deleteGcpCredentials())
        this.store.dispatch(deleteAzureCredentials())
        this.store.dispatch(resetPopups())
        break
      case "signIn_failure":
        console.log("Sign in failure: ", data)
        break
      case "configured":
        break
      default:
        break
    }
  }

  getUser() {
    Auth.currentAuthenticatedUser().then(user => {
      this.store.dispatch(switchUser(normaliseUser(user)))
      this.getCustomer()
      this.getActiveSubscriptions(["trial", "archie"])
    }).catch((error) => {
      console.log(error)
      this.store.dispatch(switchUser(null))
    })
  }

  async getActiveSubscriptions(productNames) {
    let params = {productIds: productNames}
    try {
      let response = await API.graphql(
        {
          query: verifyActiveSubscriptions,
          variables: params,
        }
      )
      let subscriptions = response.data.verifyActiveSubscriptions.activeSubscriptions || []
      this.store.dispatch(setSubscriptions(subscriptions))
    } catch (error) {
      console.log("Error: ", error)
    }
  }

  async getCustomer() {
    try {
      let response = await API.graphql(
        {
          query: getCurrentCustomer
        }
      )
      let customer = response.data.getCurrentCustomer
      let ownedProducts = Array.from(new Set(customer.ownedProducts))
      this.store.dispatch(setOwnedProducts(ownedProducts))
      delete customer.ownedProducts
      this.store.dispatch(updateCustomer(customer))
    } catch (error) {
      console.log("Error: ", error)
    }
  }
}

export default AmplifyBridge
